import { render } from "./IntroVideo.vue?vue&type=template&id=21ffe067&scoped=true"
import script from "./IntroVideo.vue?vue&type=script&lang=js"
export * from "./IntroVideo.vue?vue&type=script&lang=js"

import "./IntroVideo.vue?vue&type=style&index=0&id=21ffe067&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21ffe067"]])

export default __exports__